import React, { createContext, useState, useEffect, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import qs from 'query-string'
import { substeps } from '../assets/constants'
import { findIndex, flatMap, get, map, size } from 'lodash'

export const StepContext = createContext()

export const StepProvider = (props) => {
  const [step, setStep] = useState(0)
  const [stepInfos, setStepInfos] = useState({})
  const [countedSteps, setCountedSteps] = useState([])
  const [subStep, setSubStep] = useState(0)
  const [lastSteps, setLastSteps] = useState({})
  const [isBack, setIsBack] = useState(false)
  const history = useHistory()
  const { search } = useLocation()
  const { step: stepUrl = 0, substep = 0 } = qs.parse(search)
  useEffect(() => {
    const stepValues = [parseInt(stepUrl), parseInt(substep)]
    if (stepUrl != step) {
      setStep(stepValues[0])
      if (stepUrl < step) {
        setIsBack(true)
      } else {
        setIsBack(false)
      }
    } else if (substep != subStep) {
      if (substep < subStep) {
        setIsBack(true)
      } else {
        setIsBack(false)
      }
      setSubStep(stepValues[1])
    }
    setStepInfos(get(substeps, `${stepValues[0]}.steps.${stepValues[1]}`, {}))
  }, [stepUrl, substep, step, substep])

  useEffect(() => {
    setStep(parseInt(stepUrl))
    setSubStep(parseInt(substep))
    const elements = flatMap(substeps, substep => map(substep.steps)).filter(step => step.countStep)
    setCountedSteps(elements)
  }, [])

  const handleSetSubStep = (value) => {
    const params = qs.stringify({ step, substep: value })
    history.replace(`?${params}`)
  }

  const handleSetStep = (value) => {
    const params = qs.stringify({ step: value, substep: subStep })
    history.replace(`?${params}`)
  }

  const handleIncrementSubStep = () => {
    const newStep = subStep + 1
    const params = qs.stringify({ step, substep: newStep })
    history.push(`?${params}`)
  }
  const handleDecrementSubStep = () => {
    history.goBack()
  }

  const handleIncrementStep = () => {
    const newStep = step + 1
    const params = qs.stringify({ step: newStep, substep: subStep })
    history.push(`?${params}`)
  }
  const handleDecrementStep = () => {
    const step = step - 1
    setSubStep(step)
  }

  const handleGoToNextStep = () => {
    const params = qs.stringify({ step: step + 1, substep: 0 })
    history.push(`?${params}`)
  }

  const handleGoToStep = (subStepValue, stepValue) => {
    const params = qs.stringify({ step: stepValue, substep: subStepValue })
    history.push(`?${params}`)
  }

  const handleGoToStepFromRiepilogo = (subStepValue, stepValue) => {
    setLastSteps({ step, subStep })
    handleGoToStep(subStepValue, stepValue)
  }

  const handleGoToRiepilogo = () => {
    setIsBack(false)
    const { step, subStep } = lastSteps
    const params = qs.stringify({ step, substep: subStep })
    history.push(`?${params}`)
  }

  const getCurrentStep = useCallback(findIndex(countedSteps, step => step.title === stepInfos.title) + 1, [stepInfos])

  return (
    <StepContext.Provider
      value={{
        step,
        setStep: handleSetStep,
        subStep,
        setSubStep: handleSetSubStep,
        stepInfos,
        countedSteps,
        countedStepsLenght: size(countedSteps),
        getCurrentStep,
        isBack,

        lastSteps,

        handleDecrementStep,
        handleIncrementStep,
        handleDecrementSubStep,
        handleIncrementSubStep,

        handleGoToNextStep,
        handleGoToStep,
        handleGoToRiepilogo,
        handleGoToStepFromRiepilogo
      }}
    >
      {props.children}
    </StepContext.Provider>
  )
}
